import { createApiInstance } from './api.factory';

export const http = createApiInstance({
  baseURL: import.meta.env.VITE_BASE_URL,
  withAuth: true,
});

export const httpReports = createApiInstance({
  baseURL: import.meta.env.VITE_REPORTS_URL,
  withAuth: true,
});

export const httpMultiTransaction = createApiInstance({
  baseURL: import.meta.env.VITE_MULTITRANSACTION_URL,
  withAuth: true,
});

export const httpPublic = createApiInstance({
  baseURL: import.meta.env.VITE_BASE_URL,
  withAuth: false,
});

export const httpB2b = createApiInstance({
  baseURL: import.meta.env.VITE_B2B_URL,
  withAuth: true,
});

export const httpMcp = createApiInstance({
  baseURL: '',
  withAuth: true,
});

export const httpV3 = createApiInstance({
  baseURL: import.meta.env.VITE_BASE_URL,
  withAuth: true,
  extraHeaders: {
    'X-API-VERSION': '3',
  },
});
